


















import {Vue, Component, Prop} from 'vue-property-decorator';
import Change, {InstanceId} from "@/components/history/dto/Change";
import moment from "moment";

@Component({})
export default class ReferenceChangeView extends Vue {
	@Prop()
	private change!: Change<any>

	@Prop()
	private schema!: any

	@Prop()
	private label!: string

	@Prop({required: false})
	private action?: (change: InstanceId) => void

	private invokeAction(data: any) {
		if (this.isReferenceChangeObject(data) && this.action && data) {
			this.action(new InstanceId(data));
		}
	}

	formatValue(value: unknown, property: string | null = null): string {
		if (value === null || value === undefined) {
			return '—';
		}

		if (this.isReferenceChangeObject(value)) {
			return this.formatReferenceChangeObject(value, property);
		}


		if (typeof value === 'object') {
			return JSON.stringify(value, null, 2);
		}
		return moment(String(value)).isValid() ? moment(String(value)).format('M.DD.YYYY') : String(value);
	}

	private isReferenceChangeObject(value: any): boolean {
		return value &&
			typeof value === 'object' &&
			value.props &&
			value.cdoId &&
			value.typeName;
	}

	private formatReferenceChangeObject(value: any, property: string | null = null): string {
		const props = value.props;
		if (!props || typeof props !== 'object') {
			return JSON.stringify(value, null, 2);
		}

		const formattedValues: string[] = [];

		Object.keys(props).forEach(key => {
			const propValue = props[key];
			if (propValue !== null && propValue !== undefined) {
				const label = this.schema[property!][key];
				formattedValues.push(`${label}: ${moment(propValue).isValid() ? moment(propValue).format('M.DD.YYYY') : propValue}`);
			}
		});

		if (formattedValues.length == 0) {
			// Добавляем дополнительную информацию
			if (value.cdoId) {
				formattedValues.push(`ID: ${value.cdoId}`);
			}
			if (value.typeName) {
				const typeName = value.typeName.split('.').pop(); // Берем только имя класса
				formattedValues.push(`Type: ${typeName}`);
			}
		}

		return formattedValues.join('\n');
	}
}
